import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { mapKeysToCamelCase } from '../utils/mapPropsToCamelCase';

/**
 * @param {string} username
 * @returns {Promise<{isOnline: boolean}>}
 */
export const getIsUserOnline = async (username) => {
    const isOnlineUrl = pathfinder('is_online', { username });

    try {
        const resp = await axios.get(isOnlineUrl);

        return mapKeysToCamelCase(resp.data);
    } catch (e) {
        logger.error(e);
        return { isOnline: false };
    }
};
